var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.558 30a1.404 1.404 0 01-1.015-2.372 16.863 16.863 0 00-.004-23.26 1.404 1.404 0 012.033-1.935l.004.004a19.67 19.67 0 01-.002 27.129 1.398 1.398 0 01-1.016.434zm-3.904-3.465a1.404 1.404 0 01-1.015-2.372 11.84 11.84 0 00-.003-16.328 1.404 1.404 0 012.036-1.933 14.646 14.646 0 01-.002 20.2 1.398 1.398 0 01-1.015.433zm-3.903-3.454a1.404 1.404 0 01-1.017-2.371 6.844 6.844 0 00-.003-9.422 1.403 1.403 0 012.036-1.931l.002.002a9.652 9.652 0 01-.001 13.286 1.402 1.402 0 01-1.017.436zm-3.958-3.5a1.403 1.403 0 01-.954-2.433 1.503 1.503 0 00-.002-2.298 1.403 1.403 0 011.906-2.058l.006.005a4.304 4.304 0 01-.002 6.41 1.395 1.395 0 01-.954.374z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--contactless-payment-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'ContactlessPaymentIcon';
export default Icon;